// Shown instead of the app shell (or onboarding) while the onboarding status
// can't be read: we don't know yet where this athlete belongs. The context
// keeps retrying on its own; Try again retries now. (Figma "Web · Reconnecting":
// a page of its own, no brand panel.)
import React from 'react';
import { STATUS_RECONNECTING } from '../lib/retryLoader';
import { Button } from './ds';
import { AppStatePage, StatusPanel } from './auth/AuthLayout';

export default function StatusReconnecting({ onRetry, onLogout }) {
  return (
    <AppStatePage>
      <div role="status">
        <StatusPanel icon="spinner" title={STATUS_RECONNECTING.title} body={STATUS_RECONNECTING.body}>
          <Button block onClick={() => onRetry?.()}>{STATUS_RECONNECTING.retry}</Button>
          {onLogout && (
            <Button block kind="text" onClick={() => { Promise.resolve(onLogout()).catch(() => {}); }}>Log out</Button>
          )}
        </StatusPanel>
      </div>
    </AppStatePage>
  );
}
